const STAGING_AI_INSIGHTS_URL = 'https://staging-ai-insights-and-trends-fekv67xtza-ew.a.run.app';

const ENV_CONFIG = {
  // Opt-in build for bridged-local-stack: set REACT_APP_BRIDGED_ENV=local at build time
  local: {
    API_URL: process.env.REACT_APP_API_URL || 'http://localhost:4300',
    FLIPCARD_URL: process.env.REACT_APP_IFRAME_URL || 'http://localhost:4100',
    PLUGIN_ID: 'emhhoipfejbinjafgafpfljgpacfaebg',
    AI_INSIGHTS_URL: process.env.REACT_APP_AI_INSIGHTS_URL || STAGING_AI_INSIGHTS_URL,
  },

  dev: {
    API_URL: 'https://dev-gateway.bridged.media',
    FLIPCARD_URL: 'https://dev-agent-card.bridged.media',
    PLUGIN_ID: 'emhhoipfejbinjafgafpfljgpacfaebg',
  },

  staging: {
    API_URL: 'https://stg-gateway.bridged.media',
    FLIPCARD_URL: 'https://stg-agent-card.bridged.media',
    PLUGIN_ID: 'emhhoipfejbinjafgafpfljgpacfaebg',
  },

  production: {
    API_URL: 'https://gateway.bridged.media',
    FLIPCARD_URL: 'https://agent-card.bridged.media',
    PLUGIN_ID: 'emhhoipfejbinjafgafpfljgpacfaebg',
  },
};

const hostname = window.location.hostname;

function getLocalEnvironmentOverride() {
  const params = new URLSearchParams(window.location.search);

  return params.get('env');
}

function resolveEnvironment() {
  // build-time local stack setting wins over every hostname rule
  if (process.env.REACT_APP_BRIDGED_ENV === 'local') {
    return ENV_CONFIG.local;
  }

  // localhost behavior
  if (hostname.includes('localhost')) {
    const localEnv = getLocalEnvironmentOverride();

    if (localEnv && ENV_CONFIG[localEnv]) {
      return ENV_CONFIG[localEnv];
    }

    // default local env
    return ENV_CONFIG.staging;
  }

  // deployed staging
  if (hostname.includes('stg')) {
    return ENV_CONFIG.staging;
  }

  // deployed dev
  if (hostname.includes('dev')) {
    return ENV_CONFIG.dev;
  }

  // production fallback
  return ENV_CONFIG.production;
}

const currentEnv = resolveEnvironment();

export const { API_URL, FLIPCARD_URL, PLUGIN_ID } = currentEnv;

export const AI_INSIGHTS_URL = currentEnv.AI_INSIGHTS_URL || STAGING_AI_INSIGHTS_URL;
